import { render, staticRenderFns } from "./personDetails.vue?vue&type=template&id=13e87714&scoped=true&"
import script from "./personDetails.vue?vue&type=script&lang=js&"
export * from "./personDetails.vue?vue&type=script&lang=js&"
import style0 from "./personDetails.vue?vue&type=style&index=0&id=13e87714&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e87714",
  null
  
)

export default component.exports